// reused across listings: behavior is driven entirely by data-list-key
// data-default-columns on .column-selector and data-column-key on the table's th/td.

$(function () {
  function columnCheckboxes($selector) {
    return $selector.find('.column-list .column-checkbox').not('[id$="-select-all"]');
  }

  function selectAllCheckbox($selector) {
    return $selector.find('.column-list .column-checkbox[id$="-select-all"]');
  }

  function updateColumnCount($selector) {
    var $checkboxes = columnCheckboxes($selector);
    var checkedCount = $checkboxes.filter(':checked').length;
    var total = $checkboxes.length;
    $selector.find('.column-count-value').text(' (' + checkedCount + ' of ' + total + ' shown)');

    $selector.find('.column-selector-trigger')
      .toggleClass('has-active-columns', checkedCount > 0)
      .find('.active-columns-count').text('(' + checkedCount + ')');
  }

  function syncSelectAll($selector) {
    var $checkboxes = columnCheckboxes($selector);
    selectAllCheckbox($selector).prop('checked', $checkboxes.length === $checkboxes.filter(':checked').length);
  }

  function toggleTableColumn(key, visible) {
    $('[data-column-key="' + key + '"]').toggleClass('d-none', !visible);
  }

  function csrfToken() {
    var meta = document.querySelector('[name="csrf-token"]');
    return meta ? meta.content : null;
  }

  function persistVisibleColumns($selector) {
    var listKey = $selector.data('list-key');
    if (!listKey) return;

    var visibleColumns = columnCheckboxes($selector).filter(':checked').map(function () {
      return $(this).val();
    }).get();

    fetch('/column_preferences/' + encodeURIComponent(listKey), {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken()
      },
      credentials: 'same-origin',
      body: JSON.stringify({ visible_columns: visibleColumns })
    }).catch(function (error) {
      if (window.rollbar) window.rollbar.error('Error saving column preferences:', error);
    });
  }

  var persistVisibleColumnsDebounced = typeof debounce === 'function' ? debounce(persistVisibleColumns, 600) : persistVisibleColumns;

  $(document).on('click', '.column-selector-trigger', function (e) {
    e.preventDefault();
    $(this).closest('.column-selector').find('.column-dropdown').toggleClass('d-none');
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.column-selector').forEach(function (selector) {
      var isClickInside = selector.contains(event.target);
      if (!isClickInside) selector.querySelector('.column-dropdown')?.classList.add('d-none');
    });
  });

  $(document).on('change', '.column-selector .column-checkbox', function () {
    var $checkbox = $(this);
    var $selector = $checkbox.closest('.column-selector');

    if ($checkbox.is(selectAllCheckbox($selector))) {
      var checked = $checkbox.is(':checked');
      columnCheckboxes($selector).prop('checked', checked).each(function () {
        toggleTableColumn($(this).val(), checked);
      });
    } else {
      toggleTableColumn($checkbox.val(), $checkbox.is(':checked'));
      syncSelectAll($selector);
    }

    updateColumnCount($selector);
    persistVisibleColumnsDebounced($selector);
  });

  $(document).on('click', '.hide-column-option', function (e) {
    e.preventDefault();

    var key = $(this).data('column-key');
    // reuse the existing checkbox change handler to keep table + counts + persistence all in sync
    $('.column-selector .column-checkbox[value="' + key + '"]').prop('checked', false).trigger('change');
  });

  $(document).on('click', '.column-selector .reset-columns', function () {
    var $selector = $(this).closest('.column-selector');
    var listKey = $selector.data('list-key');
    var defaultColumns = $selector.data('default-columns') || [];

    columnCheckboxes($selector).each(function () {
      var checked = defaultColumns.indexOf($(this).val()) !== -1;
      $(this).prop('checked', checked);
      toggleTableColumn($(this).val(), checked);
    });

    syncSelectAll($selector);
    updateColumnCount($selector);

    if (!listKey) return;

    fetch('/column_preferences/' + encodeURIComponent(listKey), {
      method: 'DELETE',
      headers: { 'X-CSRF-Token': csrfToken() },
      credentials: 'same-origin'
    }).catch(function (error) {
      if (window.rollbar) window.rollbar.error('Error resetting column preferences:', error);
    });
  });
});
